<div class="mobile-step-two">
  <div class="mobile-step-two__inner">
    <h4 class="mobile-step-two__title">
      {{ 'searchSubscription.yourDetails' | i18n }}
    </h4>

    <div class="mobile-step-two__filter-chips">
      <lib-filter-chips>
        <div class="mobile-step-two__modify-filters">
          <button
            class="change-filter-button"
            (click)="emitRequestPreviousStep()"
          >
            {{ 'searchSubscription.overlay.changeFilter.mobile.button' | i18n }}
          </button>

          <i class="material-icon material-icon--outlined modify-filter-icon"
            >edit</i
          >
        </div>
      </lib-filter-chips>
    </div>

    <div class="mobile-step-two__form">
      <lib-search-subscription-form></lib-search-subscription-form>
      <p
        class="mobile-step-two__legal_notes caption caption--grey"
        [innerHTML]="'searchSubscription.form.thirdPartyHint' | i18n"
      ></p>
    </div>
  </div>
</div>
